
export const toggle = (() => {

    const toogleBtns = document.querySelectorAll("button[aria-controls]");
    const toogleParents = document.querySelectorAll("a[toggleparentclass]");
    const toogleToSetup = document.querySelectorAll('.accordion .accordion--hidden');
    
     Array.from(toogleToSetup).forEach((el) => {
        if(el.classList.contains('accordion-content')) {
            const hasToggleBtn = el.id && document.querySelector(`[aria-controls~="${el.id}"]`);
            if (hasToggleBtn) {
                el.classList.add('hidden');
                el.setAttribute('aria-hidden', 'true');
            }
        }
        el.classList.remove('accordion--hidden');
     }
    );

    Array.from(toogleParents).forEach((el) => {
        el.addEventListener("click", function(e) {
            e.preventDefault();
            const className = el.getAttribute("toggleparentclass");
            if (className && el.parentElement) {
                el.parentElement.classList.toggle(className);
            }
        });
    });

    //loops through all buttons and adds listener for click
    Array.from(toogleBtns).forEach((toggleBtn) => addEL(toggleBtn));

    function addEL(toggleBtn) {

        const classNames = ['video-play', 'pinsongplay', 'mainNav-lvl2-toggle'];

        if (classNames.some(className => toggleBtn.classList.contains(className)))
            return;


        const targetId = toggleBtn.getAttribute("aria-controls");
        const targetIds = targetId.split(" ");
        const multipleTargets = targetIds.length - 1;

        toggleBtn.addEventListener("click", function () {

            if (multipleTargets) {

                targetIds.forEach((element) => {
                    let targetEl = document.getElementById(element);
                    targetEl.setAttribute(
                        "aria-hidden",
                        targetEl.getAttribute("aria-hidden") === "true" ? "false" : "true"
                    );
                    targetEl.classList.toggle("hidden");
                });
            } else {

                let targetEl = document.getElementById(targetId);
                targetEl.setAttribute(
                    "aria-hidden",
                    targetEl.getAttribute("aria-hidden") === "true" ? "false" : "true"
                );
                targetEl.classList.toggle("hidden");
            }

            const allBtns = document.querySelectorAll(
                '[aria-controls="' + targetId + '"]'
            );

            Array.from(allBtns).forEach((b) => {
                b.setAttribute(
                    "aria-expanded",
                    b.getAttribute("aria-expanded") === "true" ? "false" : "true"
                );
            });
        });
    }
})();
